import React from "react";
import Select from 'react-select';
import COLORS from "../styles/COLORS";

const SelectInput = (props) => {

  //const data = props.options;
  const colourStyles = {
    control: (styles) => ({
      ...styles, backgroundColor: 'white',
      boxShadow: null,
      borderColor: COLORS.green,
      height: '10px',
      minHeight: '1.8pc',
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none',
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
            ? COLORS.green
            : isFocused
              ? COLORS.green//color.alpha(0.1).css()
              : undefined,
        color: data.color
      };
    },
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: props.data ? '#e9ecef' : null,
      borderColor: '#ced4da',
      // borderColor:props.data?'#ced4da':null,
      //background: "#fff",
      //backgroundColor: 'red',
      //          background: 'transparent',
      //        borderColor: 'transparent',
      //      marginTop: '-2px',
      //opacity: 1,
      // match with the menu
      borderRadius: 3,
      // Overwrittes the different states of border
      // Removes weird border around container
      boxShadow: null,
      '&:hover': {
        boxShadow: '0 0 0 0.25rem rgb(13 110 253 / 25%)',
        outline: '0 0 0 0.25rem rgb(13 110 253 / 25%)',
        borderColor: '#86b7fe',
      },
      '&:focus-within': {
        boxShadow: '0 0 0 0.25rem rgb(13 110 253 / 25%)',
        outline: '0 0 0 0.25rem rgb(13 110 253 / 25%)',
        borderColor: '#86b7fe',
      },

      //boxShadow: '0 0 0 0.25rem rgb(13 110 253 / 25%)',
      // '&:hover': {
      // borderColor: 'transparent',
      //        background: 'transparent',
      //    },
      height: '10px',
      minHeight: '2pc',
      width: props.style1?.width || '100%',
      marginLeft: props.style1?.marginLeft || "",
    }),
    menu: base => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // beautify the word cut by adding a dash see https://caniuse.com/#search=hyphens for the compatibility
      hyphens: "auto",
      // kill the gap
      marginTop: 0,
      textAlign: "left",
      // prevent menu to scroll y
      wordWrap: "break-word",
      width: props.style1?.width || '100%',
      marginLeft: props.style1?.marginLeft || "",
    }),
    menuList: base => ({
      ...base,
      // kill the white space on first and last option
      padding: 0

    }),
    valueContainer: (base) => ({
      ...base,
      //padding: '0px 12px',
      //paddingBottom: '6px'
      fontSize: '14px',
      marginTop: '2px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      //paddingTop: 0,
      //paddingBottom: '4px', 
      //color: "hsl(0,0%,60%)"
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      display: 'none',
    }),
    clearIndicator: (styles) => ({
      ...styles,
      marginBottom: 0,
      // marginTop: '-2px'
    }),
    singleValue: (style) => ({
      ...style,
      color: '#212529'
      //paddingBottom: '0.2pc'
    }),
    multiValue: (styles) => ({
      ...styles,
      //marginBottom:'8px'
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      //padding: '2px'
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      paddingLeft: '2px',
      paddingRight: '2px'
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999
    }),
    // option: (provided, state) => ({ 
    //   ...provided,
    //   color: (option => option),
    //   backgroundColor: props?.prevValue?.value === state.value ? '#add8e6' : state.isSelected ? '#00aa7e' : 'inherit',
    //   //backgroundColor: props?.prevValue === "10" ? '#add8e6' : state.isSelected ? '#00aa7e' : 'inherit',
    //   '&:hover': { backgroundColor: state.isSelected ? '#00aa7e' : '#00aa7e' }
    // }),

    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
            ? COLORS.green
            : isFocused
              ? '#00aa7e4d'//color.alpha(0.1).css()
              : undefined,
        color: data.color,

        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : '#00aa7e4d'
            : undefined,
        },
      };
    },
  };

  return (
    <Select
      name={props.name}
      id={props.id}
      onChange={props.onChange}
      //styles={customStyles}
      styles={props?.prevValue ? colourStyles : customStyles}
      options={props.options}
      value={props.value}
      //disabled={props.data?props.data:props.disabled}
      isDisabled={props.data ? props.data : props.disabled}
      defaultValue={props.defaultValue}
      placeholder={props.placeholder}
    //getOptionValue={props?.prevValue?.value}
    />
  );
};

export default SelectInput;
